// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1NeKc","right":"styles_right__3KF-R"};